export type ClientLogType = 'api' | 'ui' | 'js';
export type ClientSeverity = 'error' | 'warn' | 'info';

export type ClientLogEvent = {
  type: ClientLogType;
  severity: ClientSeverity;
  message: string;
  stack?: string;
  route?: string;
  meta?: Record<string, any>;
};

const ENDPOINT = '/ecpp/client-logs/ingest';
const MAX_BATCH = 20;
const FLUSH_MS = 1000;

const queue: ClientLogEvent[] = [];
let timer: number | null = null;

function scheduleFlush() {
  if (timer) return;
  timer = window.setTimeout(() => {
    timer = null;
    flush().catch(() => {});
  }, FLUSH_MS);
}

async function flush() {
  if (!queue.length) return;

  const batch = queue.splice(0, MAX_BATCH);
  const body = JSON.stringify({events: batch});

  const ok = navigator.sendBeacon?.(ENDPOINT, new Blob([body], {type: 'application/json'}));
  if (ok) return;

  await fetch(ENDPOINT, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    keepalive: true,
    body,
  });
}

export const clientLogger = {
  log(event: ClientLogEvent) {
    queue.push({
      ...event,
      route: event.route ?? window.location.pathname,
    });

    if (queue.length >= MAX_BATCH) flush().catch(() => {});
    else scheduleFlush();
  },
};
